import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const PartiesRoute = lazy(() => import("@/pages/parties.page"));

export const Route = createFileRoute("/parties")({
  component: PartiesRoute,
});
